<template>
    <div class="homeWrap">
        <router-view />
    </div>
</template>

<script>
    // import {json,wordData,utils} from '@/common/common.js'
    
    export default {
        name: 'HelloWorld',
        data() {
            return {
                currentActiveId: '',
                activeWords: [{
                    text: '春夏发布会',
                    value: 1
                }, {
                    text: '秋冬订货会',
                    value: 2
                }],
            }
        },
        components:{},
        methods:{
            toPage(url){
                this.$router.push(
                
                )
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .homeWrap {
        .ceshi {
            color: red;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/active/frame.vue